import I18n from 'i18n-js'
import { setLocale } from 'yup'
import './translations'

I18n.defaultLocale = 'en'
I18n.locale = document.documentElement.getAttribute('lang') || I18n.defaultLocale

export const t = I18n.t.bind(I18n) as typeof I18n.t

export const currentLocale = I18n.locale

setLocale({
  mixed: {
    default: t('activerecord.errors.messages.invalid'),
    required: t('activerecord.errors.messages.blank'),
    notType: t('activerecord.errors.messages.invalid')
  },
  string: {
    matches: t('activerecord.errors.messages.invalid'),
    email: t('activerecord.errors.messages.invalid_email')
  },
  number: {
    /* eslint-disable no-template-curly-in-string */
    min: t('activerecord.errors.messages.greater_than_or_equal_to', {
      count: '${min}'
    }),
    max: t('activerecord.errors.messages.less_than_or_equal_to', {
      count: '${max}'
    }),
    lessThan: t('activerecord.errors.messages.less_than', { count: '${less}' }),
    moreThan: t('activerecord.errors.messages.more_than', { count: '${more}' })
    /* eslint-enable no-template-curly-in-string */
  },
  array: {
    max: t('activerecord.errors.messages.less_than_or_equal_to', {
      count: '${max}'
    })
  }
})

export default I18n
